import React from "react";
import style from "./style.module.scss";
import { useTranslation } from 'react-i18next';

function Tuile({country, image, title, link, position, picto}){
    const {t} = useTranslation();
    
    return <a className={`${style.tuile} ${style[position]}`} href={link}>
        <img className={style.image} src={image} alt={""} />
        <div className={style.content}>
            <img className={style.picto} src={picto} alt={""} />
            <div className={style.country}>{country}</div>
            <div className={style.text} dangerouslySetInnerHTML={{__html:title}} />
        </div>
        <div className={style.seeMore}>{t('Lire la suite')}</div>
    </a>
}

export default Tuile;